import React, { useState } from "react";
import NavResponsive from "../../Components/FormElements/NavResponsive";
import BreadCrumbs from "../BreadCrumbs";
import IconBack from "../../Resources/svg/Icons/IconBack";
import { useHistory, useLocation } from "react-router-dom";
import IconHolder from "../../Resources/svg/Icons/IconHolder";
import IconMoney from "../../Resources/svg/Icons/IconMoney";
import { ModalitiesForm } from "../../Components/modalitiesForm";
import { useFormRVEO } from "../../Components/hooks/useFormRVEO";
import { MODALITIES } from "../../Utils/constants";

export const DetailPageRVEO = () => {
  const history = useHistory();
  const location = useLocation();
  const navigationPrev = () => {
    history.goBack();
  };

  const data = location.item;
  const [wasRecalculate, setWasRecalculate] = useState(false);
  const [showModalMod, setShowModalMod] = useState(false);

  const {
    modalitiesOptions,
    registerModalitie,
    modalitiesSelect,
    currencyData,
    tempYearsData,
    deferredYearsData,
    guaranteedYearsData,
    errorsModalitie,
    currencyMod,
    guarYearsMod,
    defYearsMod,
    tempYearsMod,
    handleAddModalitie,
    handleSubmitModalitie,
  } = useFormRVEO();
  return (
    <>
      <div className="wrap">
        <NavResponsive
          position={0}
          title={"Detalle de Simulaciones"}
          subtitle=" "
          hidden={true}
          justBack={true}
        />
        <div className="content-box d-flex">
          <div className="nav-case">
            <BreadCrumbs
              rutas={[{ link: "Simulaciones" }, { link: "Detalle" }]}
            />
            <div className="back-responsive">
              <div className="back-responsive__box">
                <IconBack
                  className="nav-case__back"
                  // onClick={() => history.push(-1)}
                />
                <div className="back-responsive__text">Volver</div>
              </div>
            </div>
            <div className="nav-case__routing">
              <IconBack className="nav-case__back" onClick={navigationPrev} />
              <div className="nav-case__title">{"Detalle de simulación"}</div>
            </div>
          </div>
          <div className="form-register approve-quote">
            <span className="title">
              Visualiza los detalles de la simulación.
            </span>

            <div className={"card-verify " + `${""}`}>
              <div className="card-verify__header">
                <IconHolder title={"title"} />
                <div className="card-verify__title">
                  {"DATOS DEL CONTRATANTE"}
                </div>
              </div>

              <div className="card-verify__body">
                <div className="card-verify__quote">CUSSP:</div>

                <div className={`card-verify__data ${false ? "is-label" : ""}`}>
                  {data.cuspp}
                </div>
              </div>

              <div className="card-verify__body">
                <div className="card-verify__quote">DNI/CE:</div>

                <div className={`card-verify__data ${false ? "is-label" : ""}`}>
                  76218612
                </div>
              </div>

              <div className="card-verify__body">
                <div className="card-verify__quote">Nombres:</div>

                <div className={`card-verify__data ${false ? "is-label" : ""}`}>
                  Nombre test
                </div>
              </div>

              <div className="card-verify__body">
                <div className="card-verify__quote">Fondo Cotizado:</div>

                <div className={`card-verify__data ${false ? "is-label" : ""}`}>
                  98917248
                </div>
              </div>

              <div className="card-verify__body">
                <div className="card-verify__quote">Prestación:</div>

                <div className={`card-verify__data ${false ? "is-label" : ""}`}>
                  Invalidez total
                </div>
              </div>
            </div>

            <div className={"card-verify " + `${""}`}>
              <div className="card-verify__header">
                <IconMoney title={"title"} />
                <div className="card-verify__title">{"MODALIDADES"}</div>
              </div>

              {data.modalities &&
                [1, 2, 3, 4, 5].map((item: any) => (
                  <div className="card-verify__beneficiary">
                    <div className="card-verify__body">
                      <div className="card-verify__quote">
                        Tipo de modalidad
                      </div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        RVA
                      </div>
                    </div>
                    <div className="card-verify__body">
                      <div className="card-verify__quote">TIR</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        0325
                      </div>
                    </div>
                    <div className="card-verify__body">
                      <div className="card-verify__quote">TV</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        2365
                      </div>
                    </div>
                    <div className="card-verify__body">
                      <div className="card-verify__quote">Pensión</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        6523.00
                      </div>
                    </div>
                    <div className="card-verify__body">
                      <div className="card-verify__quote">
                        {" "}
                        Partición capital
                      </div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        5
                      </div>
                    </div>
                    <div className="card-verify__body">
                      <div className="card-verify__quote">Reajuste:</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        Si
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">Tipo de cambio</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        PEN
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">Tipo de renta</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        025
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">
                        Fecha de operación
                      </div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        06/12/12
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">Total</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        S/. 256.00
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">Prima única</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        0.25
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">
                        Capital renta temporal
                      </div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        2365.522
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">Comisión</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        8.25
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">Tasa de venta</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        3526
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">
                        Cesión de comisión
                      </div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        8.25
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">VAN</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        368
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">Comisión</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        8.25
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">Renta vitalicia</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        65.265
                      </div>
                    </div>

                    <div className="card-verify__body">
                      <div className="card-verify__quote">PERD. CONT (%)</div>

                      <div
                        className={`card-verify__data ${
                          false ? "is-label" : ""
                        }`}
                      >
                        3
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <ModalitiesForm
        title="Mejorar Modalidad"
        onSubmit={handleSubmitModalitie((mod: any) => handleAddModalitie(mod))}
        open={showModalMod}
        close={() => setShowModalMod(false)}
        modData={modalitiesOptions}
        register={registerModalitie}
        modalitiesSelect={modalitiesSelect}
        currency={currencyData}
        deferredYears={deferredYearsData}
        tempYears={tempYearsData}
        guaranteedYears={guaranteedYearsData}
        errors={errorsModalitie}
        disableSend={
          !modalitiesSelect ||
          !currencyMod ||
          (modalitiesSelect === MODALITIES.RENTA_VITALICIA && !guarYearsMod) ||
          (modalitiesSelect === MODALITIES.RENTA_VITALICIA_ESCALONADA && (!guarYearsMod || !tempYearsMod)) ||
          (modalitiesSelect === MODALITIES.RENTA_TEMPORAL_VITALICIA_DIFERIDA && (!guarYearsMod || !defYearsMod))
        }
        upgrade={true}
      />
    </>
  );
};
